
const standardizeVRData = (metrics) => {
    try {
        const latestScore = metrics.data && Array.isArray(metrics.data.scores) ?
            metrics.data.scores[metrics.data.scores.length - 1] : {};

        const attempts = metrics.data.scores ? metrics.data.scores.length : 0; // Pegue o número de tentativas

        return {
            data: {
                status_code: 200,
                result: {
                    overall_score: latestScore != null && latestScore.attempt_score ? latestScore.attempt_score : '',
                    overall_metrics: {
                        ielts_score: null,
                        ielts_fluency: null,
                        word_count: latestScore != null && latestScore.phrase ? latestScore.phrase.split(" ").length : 0,
                        syllable_count: null,
                        phone_count: null,
                    },
                    detailed: {
                        words: latestScore.phrase ? latestScore.phrase.split(" ").map(word => ({
                            word: word,
                            quality_score: latestScore != null && latestScore.attempt_score ? latestScore.attempt_score : '',
                            start: 0,
                            stop: 0
                        })) : [],
                        syllables: [],
                        phonemes: []
                    }
                },
                text: latestScore != null && latestScore.phrase ? latestScore.phrase : '',
                audio_duration_seconds: metrics.audio_duration || 0,
                attempts // Inclua o número de tentativas padronizado
            }
        };
    } catch (error) {
        throw new Error(error || "Ops! An Error occurs at standardizeVRData");
    }
};


const sendDataProgressTrackerMetrics = async (userInfo, lessonId, lessonName,
    totalIndexes,
    blockData, overall_score, newRecordingAttempts,
    engagementTime, data, callbackRegisterMetrics, vrProvider) => {

    const params = {
        userId: userInfo.id,
        blockId: blockData.block_id, //TODO:// Check if it's the same as blockData.block_id
        template: "simplesentence_vr",
        bookName: data.book_name,
        lessonId: lessonId,
        scores: [{
            user_id: String(userInfo.id),
            user_name: userInfo.username,
            book_name: data.book_name,
            lesson_name: lessonName,
            section_name: data.section,
            exercise_id: String(data.id),
            phrase: data.en, // the full phrase or sentence
            attempt: newRecordingAttempts,
            attempt_score: Number(overall_score),
            engagement_time: Number(engagementTime),
            // voice_recognition: "speechace",
            voice_recognition: vrProvider,
        }],
        sectionId: blockData.sectionId,
        section: blockData.section,
        index: blockData.num,
        totalIndexes: totalIndexes
    };

    await callbackRegisterMetrics(params);

    console.log("success", `At method sendDataProgressTrackerMetrics
      - send Data ${vrProvider} Metrics to Progress Tracker - Data is ${JSON.stringify(params)}`);

};

export { standardizeVRData, sendDataProgressTrackerMetrics }